import UserFinalizeCart from "@/components/cart/UserFinalizeCart.vue";
import ConsultantFinalizeCart from "@/components/cart/ConsultantFinalizeCart.vue";
import AdminFinalizeCart from "@/components/cart/AdminFinalizeCart.vue";
import { isAdminNotConsultant, isConsultantOrHolding, isConsultantNotHolding, isUserBuyerGroup } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
export default {
  name: "finalizeCart",
  components: {
    UserFinalizeCart: UserFinalizeCart,
    ConsultantFinalizeCart: ConsultantFinalizeCart,
    AdminFinalizeCart: AdminFinalizeCart
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      order: null
    };
  },
  computed: {
    isOrderForConsultantHimself: function isOrderForConsultantHimself() {
      return isConsultantNotHolding(this.loggedUserData) && this.order.id_user === +this.loggedUserData.idUser;
    }
  },
  created: function created() {
    this.order = orderHandler.getCurrentOrder();
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isUserBuyerGroup: isUserBuyerGroup
  }
};